import { ChampionSkill } from "@outplayed/tooltips";
import { getRiotAssetsContext, IndividualChampion } from "@outplayed/riot-assets";
import { ChampionBalance } from "@ugg/shared/interfaces/champions/queue-type-balances.interface";

const getImageFromName = (target: string, championId: number, championData?: IndividualChampion) => {
  const { getChampionSkillNames, getChampionPassiveJSON } = getRiotAssetsContext();
  const championAbilities = getChampionSkillNames(championId, { optionalData: championData });

  for (let i = 0; i < championAbilities.length; i++) {
    if (championAbilities?.[i]?.toLowerCase()?.trim() === target.toLowerCase()) {
      return <ChampionSkill className="image" championId={championId} skillSlot={i} ssr isPassive={false} />;
    }
  }
  const passive = getChampionPassiveJSON(championId, { optionalData: championData || undefined });
  if (passive && passive?.name?.toLowerCase().trim() === target.toLowerCase()) {
    return <ChampionSkill className="image" championId={championId} ssr isPassive={true} />;
  }
};

export const filterModStats = (targetChampStats: ChampionBalance, championId: number, championData?: IndividualChampion) => {
  let championChanges = [];
  let abilityChanges = [];
  let damageDealt = [];
  let entireChange, difference, amountChanged: number, changeDescription;
  const keys = Object.keys(targetChampStats) as Array<keyof typeof targetChampStats>;
  for (let key of keys) {
    const value = targetChampStats[key];
    entireChange = null;
    if (value !== 1) {
      if (key !== "abilities" && typeof value === "number") {
        amountChanged = value;
        changeDescription =
          amountChanged - 1 > 0
            ? "+" + Math.round((value - 1) * 100).toString() + "%"
            : "-" + Math.round((value - 1) * -100).toString() + "%";
        difference = amountChanged - 1 > 0 ? "increased by " : "decreased by ";
      }
      if (key === "damage_dealt") {
        damageDealt.push(
          <>
            <p className="bold-right">{changeDescription}</p> Damage dealt
          </>,
        );
      } else if (key === "damage_taken") {
        entireChange = (
          <>
            <p className="bold-right">{changeDescription}</p> Damage taken
          </>
        );
      } else if (key === "damage_healing") {
        entireChange = (
          <>
            {"Healing done " + difference}
            <p className="bold-left">{changeDescription}</p>
          </>
        );
      } else if (key === "damage_shielding") {
        entireChange = (
          <>
            {"Shielding done " + difference}
            <p className="bold-left">{changeDescription}</p>
          </>
        );
      } else if (key === "abilities") {
        if (typeof value === "object") {
          for (const [subkey, subvalue] of Object.entries(value as { [key: string]: string })) {
            const stats = subvalue.split("\n");
            if (subkey === "Stats") {
              for (const stat in stats) {
                abilityChanges.push(
                  <>
                    <p>{stats[stat]}</p>
                  </>,
                );
              }
            } else {
              const image = getImageFromName(subkey.trim(), championId, championData || undefined);
              abilityChanges.push(
                <div className="ability">
                  <div className="title">
                    {image} {subkey}
                  </div>
                  {stats.map((stat: string, idx: number) => (
                    <p className="bullets" key={idx}>
                      {stat}
                    </p>
                  ))}
                </div>,
              );
            }
          }
        }
      }
      if (entireChange !== null) {
        championChanges.push(<>{entireChange}</>);
      }
    }
  }

  const hasBalanceChanges = damageDealt.length > 0 && championChanges.length > 0 && abilityChanges.length > 0;

  return { damageDealt, championChanges, abilityChanges, hasBalanceChanges };
};
